import React from 'react';
import { Dropdown as ReactBootstrapDropdown } from 'react-bootstrap';
export const BootstrapDropdown = ({ id, toggle, children }) => {
    return (React.createElement(ReactBootstrapDropdown, { alignRight: true },
        React.createElement(ReactBootstrapDropdown.Toggle, { id: id, as: DropdownToggle }, toggle),
        React.createElement(ReactBootstrapDropdown.Menu, null, children)));
};
class DropdownToggle extends React.Component {
    render() {
        const { onClick, children } = this.props;
        return (React.createElement("button", { type: "button", onClick: onClick }, children));
    }
}
//# sourceMappingURL=Dropdown.js.map